import { OnboardingNodeType } from '../steps/types';
import { OnboardingSteps } from '../types';

const getSubmittedNodePayload = <T>(
  nodeType: OnboardingNodeType,
  steps: OnboardingSteps
): T | undefined => {
  const onboardingSteps = steps[nodeType];

  if (!onboardingSteps) {
    return undefined;
  }

  for (const step of onboardingSteps) {
    if (step.submitted) {
      return (step.payload as T) ?? undefined;
    }
  }

  return undefined;
};

export default getSubmittedNodePayload;
